import { useEffect, useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSession, useUpdateProfile } from "@/core/auth/useSession";
import { Button, Card, CardTitle, Field, Input, Switch, useToast } from "@/core/ui";
import { MyDataCard } from "./MyDataCard";
import { NotificationsCard } from "./NotificationsCard";

export function AccountPage() {
  const { t } = useTranslation();
  const { toast } = useToast();
  const session = useSession();
  const update = useUpdateProfile();
  const user = session.data?.user;
  const [form, setForm] = useState({ display_name: "", pseudonym: "", opt_out_leaderboard: false });
  useEffect(() => {
    if (user)
      setForm({
        display_name: user.display_name,
        pseudonym: user.pseudonym,
        opt_out_leaderboard: user.opt_out_leaderboard,
      });
  }, [user]);
  if (!user) return null;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    update.mutate(form, { onSuccess: () => toast(t("admin.saved"), "success") });
  };
  return (
    <div className="bt-account">
      <Card>
        <CardTitle>{t("account.title")}</CardTitle>
        <p className="bt-account__email">{user.email}</p>
        <form onSubmit={submit}>
          <Field label={t("account.display_name")} htmlFor="display_name">
            <Input
              id="display_name"
              value={form.display_name}
              onChange={(e) => setForm({ ...form, display_name: e.target.value })}
            />
          </Field>
          <Field
            label={t("account.pseudonym")}
            htmlFor="pseudonym"
            hint={t("account.pseudonym_hint")}
          >
            <Input
              id="pseudonym"
              value={form.pseudonym}
              onChange={(e) => setForm({ ...form, pseudonym: e.target.value })}
            />
          </Field>
          <Switch
            id="opt-out"
            checked={form.opt_out_leaderboard}
            onChange={(v) => setForm({ ...form, opt_out_leaderboard: v })}
            label={t("account.opt_out")}
          />
          <Button type="submit" className="bt-account__submit" loading={update.isPending}>
            {t("admin.save")}
          </Button>
        </form>
      </Card>
      <NotificationsCard email={user.email} />
      <MyDataCard email={user.email} />
    </div>
  );
}
